import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const xyPlotDescription: CalculatorDescription = {
  id: CalculatorId.XYPlot,
  title: 'XY Plot Maker',
  metaTitle: 'Free Online XY Plot Generator - Create Coordinate Graphs',
  description: 'Create XY plots to visualize mathematical functions, experimental data, and coordinate relationships. Ideal for scientific and engineering applications.',
  metaDescription: 'Generate XY plots online. Plot coordinate data and functions with our free tool. Perfect for scientific and engineering visualization.',
  howTo: {
    title: 'How to Create an XY Plot',
    steps: [
      'Input X and Y coordinates',
      'Select plot style and markers',
      'Adjust axis ranges and labels',
      'Add regression lines if needed',
      'Customize plot appearance'
    ],
    graphic: {
      description: 'An echarts XY plot with customizable markers and optional trend lines, with a shadcn table for coordinate data entry'
    }
  },
  examples: [
    {
      title: 'Experimental Data',
      description: 'Physical measurements',
      dataDescription: 'Time and distance measurements',
      insights: [
        'Visualizes experimental results',
        'Shows measurement precision',
        'Identifies systematic errors',
        'Enables data validation'
      ]
    },
    {
      title: 'Mathematical Functions',
      description: 'Function visualization',
      dataDescription: 'X values and corresponding Y values',
      insights: [
        'Displays function behavior',
        'Shows critical points',
        'Illustrates rate of change',
        'Helps understand relationships'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.ScatterChart,
    CalculatorId.LineChart,
    CalculatorId.BarGraph
  ]
}; 